export default __webpack_public_path__ + "static/media/IMG-20240708-WA0011.5b270284.jpg";